import axios from 'axios';
import {MessageBox} from 'element-ui'

axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;

axios.defaults.baseURL = '/';
// axios.defaults.baseURL = 'http://localhost:8080';
// axios.defaults.baseURL = 'https://weixin-test.whaleip.com';
// axios.defaults.baseURL = 'https://weixin.whaleip.com';
let source = axios.CancelToken.source();
axios.interceptors.request.use(config => {
    window.console.log("======= interceptors.request 拦截请求 ===== ");
    window.console.log("======= url ===== " + config.url);
    if (config.url === "/account/login") {
        return config;
    }
    let token = window.$cookies.get("token");
    if (token !== undefined && token !== null && token !== '') {
        //每次接口请求都更新token有效期
        window.$cookies.set("token", token, "30min");
    } else {
        //cookie失效重新登录，当前正在访问的请求强制中断
        source.cancel();
        MessageBox.alert('登录超时,请重新登录！', '登录超时', {
            confirmButtonText: '跳转登录页',
            callback: () => {
                window.location.href = "/";
            }
        });
    }

    return config;
});
axios.interceptors.response.use(response => {
    window.console.log("======= interceptors.request 拦截返回 ======" + response.data);
    if (response.status !== 200) {
        let message = response.toString() || response.status + "请求失败";
        return Promise.reject(message);
    }else if (response.data === "Please Login In") {
        MessageBox.alert('登录超时,请重新登录！', '登录超时', {
            confirmButtonText: '跳转登录页',
            callback: () => {
                window.location.href = "/";
            }
        });
    }
    return response;
});

/**
 * get 请求方法
 * @param url
 * @param params
 * @returns {Promise<any>}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: params, cancelToken: source.token})
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err);
            })
    })
}

/**
 * post 请求方法
 * @param url 请求路径
 * @param data 方法体参数
 * @param param 请求体参数
 * @param config
 * @returns {Promise<any>}
 */
export function post(url, data, param, config) {
    config.params = param;
    window.console.log(param);
    return new Promise((resolve, reject) => {
        axios.post(url, data, config)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * put 请求方法
 * @param url
 * @param data
 * @returns {Promise<any>}
 */
export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * delete 请求方法
 * @param url
 * @param params
 * @returns {Promise<any>}
 */
export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {params: params})
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}


